export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-popover2/index.js